import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerActivity } from './models';
import { invalidateVolunteerActivities } from './useVolunteerActivities';

export const useCloneVolunteerActivityMutation = ({
	onError,
	onSettled,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
	onSuccess?: (data: IVolunteerActivity) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			activityId,
			startDate,
			impersonationContext,
		}: {
			activityId: string;
			startDate?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerActivity>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activityId}/clone`,
				}),
				'POST',
				startDate ? { startDate } : {}
			),
		onSuccess,
		onError,
		onSettled: () => {
			invalidateVolunteerActivities();
			onSettled?.();
		},
	});
};
